const state = () => ({
  userForm: {
    ID: null,
    simRole: null,
    simPermission: null,
  },
});

const getters = {
  userForm: state => {
    return state.userForm;
  },
};

const mutations = {
  updateUserForm(state, form) {
    state.userForm = form;
  },
};

export default {
  state,
  getters,
  mutations,
};
